export default "__VITE_ASSET__NUHCWBoj__"